import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export const routes = [
  {
    path: '*',
    redirect: '/'
  }, {
    path: '/',
    name: 'PageView',
    component: resolve => require(['@/view/PageView'], resolve),
    children: [
      {
        path: '/',
        redirect: '/home',
        meta: {
          title: '东营市财金化学有限公司',
          content: "东营市财金化学有限公司"
        }
      }, {
        path: '/home',
        name: 'home',
        component: resolve => require(['@/view/HomePage'], resolve),
        meta: {
          title: '东营市财金化学-首页',
          content: "东营市财金化学有限公司"
        }
      }, {
        path: '/software',
        name: 'software',
        component: resolve => require(['@/view/Software'], resolve),
        meta: {
          title: '东营市财金化学-产品中心',
          content: "东营市财金化学有限公司"
        },
        children: [
          {
            path: '/software',
            redirect: '/software/smartTown'
          },
          {
            path: '/software/smartTown',
            name: 'software',
            component: resolve => require(['@/view/Software_smartTown'], resolve),
            meta: {
              title: '东营市财金化学-产品中心',
              content: "东营市财金化学有限公司"
            }
          },
          {
            path: '/software/bigData',
            name: 'software',
            component: resolve => require(['@/view/Software_bigData'], resolve),
            meta: {
              title: '东营市财金化学-产品中心',
              content: "东营市财金化学有限公司"
            }
          }
        ]
      }, {
        path: '/service',
        name: 'service',
        component: resolve => require(['@/view/Service'], resolve),
        meta: {
          title: '东营市财金化学-工会风采',
          content: "东营市财金化学有限公司"
        }
      }, {
        path: '/newsinformation',
        name: 'newsinformation',
        component: resolve => require(['@/view/NewsInformation'], resolve),
        meta: {
          title: '东营市财金化学-新闻动态',
          content: "东营市财金化学有限公司"
        }
      }, {
        path: '/companyintroduction',
        name: 'companyintroduction',
        component: resolve => require(['@/view/CompanyIntroduction'], resolve),
        meta: {
          title: '东营市财金化学-公司概况',
          content: "东营市财金化学有限公司"
        }
      }, {
        path: '/jobchance',
        name: 'jobchance',
        component: resolve => require(['@/view/JobChance'], resolve),
        meta: {
          title: '东营市财金化学-人才招聘',
          content: "东营市财金化学有限公司"
        }
      }, {
        path: '/contactus',
        name: 'contactus',
        component: resolve => require(['@/view/ContactUs'], resolve),
        meta: {
          title: '东营市财金化学-联系我们',
          content: "东营市财金化学有限公司"
        }
      },
      {
        path: '/servicedetail',
        name: 'servicedetail',
        component: resolve => require(['@/view/ServiceDetail'],resolve),
        meta: {
          title: '东营市财金化学-工会风采',
          content: "东营市财金化学有限公司"
        }
      }
    ]
  }
]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js